var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 4.16683L10.0002 4.17516M10.0002 10.0002L10.0002 10.0085M10.0002 15.8335L10.0002 15.8418M10.0002 5.00016C9.53993 5.00016 9.16683 4.62707 9.16683 4.16683C9.16683 3.70659 9.53993 3.3335 10.0002 3.3335C10.4604 3.3335 10.8335 3.70659 10.8335 4.16683C10.8335 4.62707 10.4604 5.00016 10.0002 5.00016ZM10.0002 10.8335C9.53993 10.8335 9.16683 10.4604 9.16683 10.0002C9.16683 9.53993 9.53993 9.16683 10.0002 9.16683C10.4604 9.16683 10.8335 9.53993 10.8335 10.0002C10.8335 10.4604 10.4604 10.8335 10.0002 10.8335ZM10.0002 16.6668C9.53993 16.6668 9.16683 16.2937 9.16683 15.8335C9.16683 15.3733 9.53993 15.0002 10.0002 15.0002C10.4604 15.0002 10.8335 15.3733 10.8335 15.8335C10.8335 16.2937 10.4604 16.6668 10.0002 16.6668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalThreeDots);
export default __webpack_public_path__ + "static/media/VerticalThreeDots.3ae73908d10eb4ab823555ed72fffc7f.svg";
export { ForwardRef as ReactComponent };